import { Middleware, MiddlewareAPI, Action } from "redux";
import {
  CHANGE_CHANNEL, CUSTOMER_METHODS_PLACE_BETS, OVERLAY_TOGGLE, STATISTIC_CENTER_OPEN, TOGGLE_QUICK_BETTING,
  VIDEO_PLAYER_PLAY, VIDEO_PLAYER_STOP
} from "../actions/actionTypes";

declare global {
    interface Window {
        srvg: any;
        SRLive: any;
    }
}


const piwikMiddleware : Middleware = store => next => action => {

  let bo = getState(store).bookmakerOptions;
  if ( bo && bo.bookmakerInstances && bo.bookmakerInstances.features &&
    bo.bookmakerInstances.features.enable_piwik_custom_variables ) {

    switch (action.type) {
      case TOGGLE_QUICK_BETTING:
        sendTrackingInfo('quick betting ' + (getState(store).gui.quickBetsState.active ? 'deactivated' : 'activated'));
        break;
      case CUSTOMER_METHODS_PLACE_BETS:
        let bets = getAction(action).data.bets[0];
        sendTrackingInfo('place bets market: ' + bets.market_id);
        break;
      case OVERLAY_TOGGLE:
        sendTrackingInfo((getState(store).gui.overlay.visibility ? 'close' : 'open') + ' overlay');
        break;
      case STATISTIC_CENTER_OPEN:
        // no additional info required
        sendTrackingInfo('open statistic center');
        break;
      case CHANGE_CHANNEL:
        if (getState(store).gui.channel.active != getAction(action).id) {
          sendTrackingInfo('channel switch');
        }
        break;
      case VIDEO_PLAYER_PLAY:
        sendTrackingInfo('video start');
        break;
      case VIDEO_PLAYER_STOP:
        sendTrackingInfo('video stop');
        break;
    }

  }
  return next(action);
}

const getState = (store: any) => {
  return store.getState();
};
const getAction = (action: any) => {
  return action;
};


export default piwikMiddleware;

const sendTrackingInfo : Function = (data: string) => {
    if ( window.srvg && window.srvg.eventExchange ) {
        window.srvg.eventExchange.triggerEvent( 'all',
            { eventType: "trackPiwik", trackType: "userInteraction", trackData: data });
    }
    else if ( window.SRLive && window.SRLive.event ) {
        window.SRLive.event.trigger('analytics:userinteraction', { eventType: "trackPiwik", trackType: "userInteraction", trackData: data });
    }
}
